
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import GroupeForm from '@/components/forms/GroupeForm.vue'
import VueScrollTo from 'vue-scrollto'

const groupeModule = namespace('groupe')

@Component({
  components: {
    BaseCardContainer,
    GroupeForm
  }
})
export default class GroupeUpdate extends Vue {
  @groupeModule.Action('getGroupeByIdAction') getGroupeById: any
  @groupeModule.Action('getGroupesAction') getGroupes: any
  @groupeModule.Action('updateGroupeAction') updateGroupe: any
  @groupeModule.Getter('groupeGetter') groupe: any

  mounted() {
    this.getGroupeById(this.$route.params.id)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.id', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getGroupeById(newVal)
  }

  onSubmit(data: any) {
    this.updateGroupe({
      id: this.$route.params.id,
      formParams: data
    }).then(async (data: any) => {
      await this.getGroupes()
      this.$router.push({name: 'groupeList'})
    })
  }

  onCancel() {
    this.$router.push({name: 'groupeList'})
  }
}
